module.exports = __webpack_public_path__ + "static/media/ic_check_24px.22a079b8.svg";